const enterpriseIds = {
  aluru_akash: "aluru.akash",
  uma_rani_battu: "uma.rani.battu",
  jeevadharani_ramanan: "jeevadharani.ramanan",
  reshmi_haridas_m: "reshmi.haridas.m",
  ankur_e_mishra: "ankur.e.mishra",
  aayushi_bharti: "aayushi.bharti",
  arpita_m_singh: "arpita.m.singh",
  jb_bhardwaj: "j.b.bhardwaj",
  varsha_a_tyagi: "varsha.a.tyagi",
  h_srinivasan: "h.srinivasan",
  yogendra_trivedi: "yogendra.trivedi",
  jb_mittal: "j.b.mittal",
  lavanya_umesh: "lavanya.umesh",
  rashi_sri: "rashi.shrivastava",
  atci_portaldevelopment: "ATCI.LKM.LIS.PORTALDEVELOPMENT",
  L_TT_FoundationAssessment: "L-TT.FoundationAssessment",
  L_TT_JobReadiness: "L-TT.JobReadiness",
  LKM_Foundation: "LKM.Foundation",
  LKM_ASEGraduation: "LKM.ASEGraduation",
  ATCI_Techexpressway: "ATCITechexpressway",
  joiner_techenable: "joiner.techenable",
  ATCI_ProfessionalAdv: "ATCI.ProfessionalAdv",
  LKM_Techleap_Support: "LKM.TECHLEAP.SUPPORT",
  ATCI_Techleap_Exams: "ATCI.TECHLEAP.EXAMS",
  ATCI_TechExpressway: "ATCITechExpressway",
  b_prasad_mishra: "b.prasad.mishra"
};

const domain = "accenture.com";
const dsdevdomain = "ds.dev.accenture.com";

const atciPortaldevelopment = `${enterpriseIds.atci_portaldevelopment}@${domain}`;

const aluruakash = `${enterpriseIds.aluru_akash}@${domain}`;
const dsdevaluruakash = `${enterpriseIds.aluru_akash}@${dsdevdomain}`;
const lavanyaumesh = `${enterpriseIds.lavanya_umesh}@${domain}`;
const dslavanyaumesh = `${enterpriseIds.lavanya_umesh}@${dsdevdomain}`;
const rashishrivastava = `${enterpriseIds.rashi_sri}@${domain}`;
const umaranibattu = `${enterpriseIds.uma_rani_battu}@${domain}`;
const dsdevumaranibattu = `${enterpriseIds.uma_rani_battu}@${dsdevdomain}`;
const jeevadharaniramanan = `${enterpriseIds.jeevadharani_ramanan}@${domain}`;
const reshmiharidasm = `${enterpriseIds.reshmi_haridas_m}@${domain}`;
const dsdevreshmiharidasm = `${enterpriseIds.reshmi_haridas_m}@${dsdevdomain}`;
const ankuremishra = `${enterpriseIds.ankur_e_mishra}@${domain}`;
const dsdevankuremishra = `${enterpriseIds.ankur_e_mishra}@${dsdevdomain}`;
const aayushibharti = `${enterpriseIds.aayushi_bharti}@${domain}`;
const dsdevaayushibharti = `${enterpriseIds.aayushi_bharti}@${dsdevdomain}`;
const arpitamsingh = `${enterpriseIds.arpita_m_singh}@${domain}`;
const dsdevarpitamsingh = `${enterpriseIds.arpita_m_singh}@${dsdevdomain}`;
const jbbhardwaj = `${enterpriseIds.jb_bhardwaj}@${domain}`;
const varshaatyagi = `${enterpriseIds.varsha_a_tyagi}@${domain}`;
const hsrinivasan = `${enterpriseIds.h_srinivasan}@${domain}`;
const yogendratrivedi = `${enterpriseIds.yogendra_trivedi}@${domain}`;
const jbmittal = `${enterpriseIds.jb_mittal}@${domain}`;
const dsdevjbmittal = `${enterpriseIds.jb_mittal}@${dsdevdomain}`;
const lttfoundationAssessment = `${enterpriseIds.L_TT_FoundationAssessment}@${domain}`;
const lttjobreadiness = `${enterpriseIds.L_TT_JobReadiness}@${domain}`;
const lkmfoundation = `${enterpriseIds.LKM_Foundation}@${domain}`;
const lkmasegraduation = `${enterpriseIds.LKM_ASEGraduation}@${domain}`;
const atcitechexpressway = `${enterpriseIds.ATCI_Techexpressway}@${domain}`;
const joinertechenable = `${enterpriseIds.joiner_techenable}@${domain}`;
const atciprofessionaladv = `${enterpriseIds.jATCI_ProfessionalAdv}@${domain}`;
const lkmtechleapsupport = `${enterpriseIds.LKM_Techleap_Support}@${domain}`;
const atcitechleapexams = `${enterpriseIds.ATCI_Techleap_Exams}@${domain}`;
const bprasadmishra = `${enterpriseIds.b_prasad_mishra}@${domain}`;

export default {
  atciPortaldevelopment,
  aluruakash,
  dsdevaluruakash,
  umaranibattu,
  dsdevumaranibattu,
  jeevadharaniramanan,
  reshmiharidasm,
  dsdevreshmiharidasm,
  ankuremishra,
  dsdevankuremishra,
  aayushibharti,
  lavanyaumesh,
  dslavanyaumesh,
  rashishrivastava,
  dsdevaayushibharti,
  arpitamsingh,
  dsdevarpitamsingh,
  jbbhardwaj,
  varshaatyagi,
  hsrinivasan,
  yogendratrivedi,
  jbmittal,
  dsdevjbmittal,
  lttfoundationAssessment,
  lttjobreadiness,
  lkmfoundation,
  lkmasegraduation,
  atcitechexpressway,
  joinertechenable,
  atciprofessionaladv,
  lkmtechleapsupport,
  atcitechleapexams,
  bprasadmishra
};
